import { render, staticRenderFns } from "./BusinessRecords.vue?vue&type=template&id=41629fc6&scoped=true&"
import script from "./BusinessRecords.vue?vue&type=script&lang=js&"
export * from "./BusinessRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41629fc6",
  null
  
)

export default component.exports